import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrashAlt, faSortDown } from '@fortawesome/pro-solid-svg-icons';

import { MenuItem, OverlayTrigger, Tooltip } from 'react-bootstrap';
import UnstyledDropdownToggle from 'components/bootstrap_extensions/unstyled_dropdown_toggle';
import Dropdown from 'components/dropdown';

// TODO: The icon has a crazy small click target - fix
// DEPRECATED: This is extremely specific and not very usable - delete in favor of the more generic components/dropdown
export default function ActionsMenu({
  deleteLabel,
  disableDelete,
  disableDeleteMessage,
  disableEdit,
  disableEditMessage,
  editIcon,
  editLabel,
  hideEdit,
  icon,
  id,
  otherOptions,
  readOnly,
  readOnlyMessage,
  onDelete,
  onShowModal
}) {
  function renderMenuItems() {
    let items = [];

    let editItem;
    if (!hideEdit) {
      editItem = (
        <MenuItem
          aria-label="edit item"
          disabled={disableEdit || readOnly}
          key="edit-item"
          name="edit-item-button"
          onClick={disableEdit || readOnly ? null : onShowModal}
        >
          <FontAwesomeIcon fixedWidth icon={editIcon || faEdit} /> {editLabel || 'Edit'}
        </MenuItem>
      );
    }

    let tooltip = null;

    if (readOnly && readOnlyMessage) {
      tooltip = (
        <Tooltip id="read-only-tooltip">
          {readOnlyMessage}
        </Tooltip>
      );
    } else if (disableEdit && disableEditMessage) {
      tooltip = (
        <Tooltip id="edit-item-tooltip">
          {disableEditMessage}
        </Tooltip>
      );
    }

    if (tooltip) {
      editItem = (
        <OverlayTrigger
          key="edit-item-overlay-trigger"
          name="edit-item-overlay-trigger"
          overlay={tooltip}
          placement="left"
        >
          {editItem}
        </OverlayTrigger>
      );
    }

    items.push(editItem);

    if (otherOptions) {
      items = [...items, ...otherOptions];
    }

    let deleteItem = (
      <MenuItem
        aria-label="delete item"
        disabled={disableDelete || readOnly}
        key="delete-item"
        name="delete-item-button"
        onClick={disableDelete || readOnly ? null : onDelete}
      >
        <FontAwesomeIcon fixedWidth icon={faTrashAlt} /> {deleteLabel || 'Delete'}
      </MenuItem>
    );

    if (disableDelete && disableDeleteMessage) {
      tooltip = (
        <Tooltip id="delete-item-tooltip">
          {disableDeleteMessage}
        </Tooltip>
      );
    } else if (!(readOnly && readOnlyMessage)) {
      tooltip = null;
    }

    if (tooltip) {
      deleteItem = (
        <OverlayTrigger
          key="delete-item-overlay-trigger"
          name="delete-item-overlay-trigger"
          overlay={tooltip}
          placement="left"
        >
          {deleteItem}
        </OverlayTrigger>
      );
    }

    items.push(deleteItem);

    return items;
  }

  return <React.Fragment>
    <Dropdown absolute aria-label="menu" id={`item-row-actions-${id}`} pullRight>
      <UnstyledDropdownToggle
        aria-label="Actions Menu Dropdown"
        bsRole="toggle"
        className="item-row-actions-toggle"
        id={`item-row-actions-toggle-${id}`}
        variant="dark"
      >
        {icon || <FontAwesomeIcon icon={faSortDown} />}
      </UnstyledDropdownToggle>
      <Dropdown.Menu>
        {renderMenuItems()}
      </Dropdown.Menu>
    </Dropdown>
  </React.Fragment>;
}

ActionsMenu.propTypes = {
  deleteLabel: PropTypes.string,
  disableDelete: PropTypes.bool,
  disableDeleteMessage: PropTypes.string,
  disableEdit: PropTypes.bool,
  disableEditMessage: PropTypes.string,
  editIcon: PropTypes.object,
  editLabel: PropTypes.string,
  hideEdit: PropTypes.bool,
  icon: PropTypes.node,
  id: PropTypes.any,
  otherOptions: PropTypes.arrayOf(PropTypes.node),
  readOnly: PropTypes.bool,
  readOnlyMessage: PropTypes.string,
  onDelete: PropTypes.func,
  onShowModal: PropTypes.func,
};
